import FlashLib from 'flashlib_onlyplay';
import EntryPoint from 'Engine/EntryPoint';
import WinAmountAnimated from '../winAmountAnimated/winAmountAnimated';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import ParticleSystem from 'Engine/particles/particleSystem';
import particlesConfig from 'Engine/particles/particleConfig';
import { goldStyle, freeSpinsWindowStyle } from '../../textStyles/styles';
import eEventTypes from '../../enums/eEventTypes';
import SoundManager from '../../libs/game-engine/src/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';

export default class ControllerFreeSpinsWindow extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.timeout = null;
    this.eventMode = 'static'
    this._totalWinDuration = 5000;
    this._addFreeSpinsDuration = 3000;
    this._delayBeforeClose = 2000;

    this.init();
    // this.initParticles();
    this.addListeners();
    this.hide();
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_ADD_START, this.initPage1, this);
    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_ADD_END, this.hide, this);

    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_OUT_START, this.initPage2, this);
    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_OUT_END, this.hide, this);

    this.on('click', () => GlobalDispatcher.dispatch(eEventTypes.EET_SPIN_CLICK));
    this.on('touchend', () => GlobalDispatcher.dispatch(eEventTypes.EET_SPIN_CLICK));
  }

  init() {
    this.content = this.getChildByName('content');

    this.winAmountCounter = new WinAmountAnimated();
    this.winAmountCounter.on('complete', this._onWinAnimationEnd.bind(this));

    const setWinToUi = (value) => {
      EntryPoint.PlayerUiAdapter.setWinValue(value);
      EntryPoint.PlayerUiAdapter.setBalanceValue(EntryPoint.GameModel.lastBalance + value);
    };

    this.winAmountCounter.onChange = setWinToUi;
  }

  hide() {
    // SoundManager.stop(sounds.SCATTER_WIN.name);
    this.visible = false;
    // this.coinsContainer.visible = false;
    // this.coinParticles.stop();
    this.winAmountCounter.stop();
    clearTimeout(this.timeout);
  }

  initPage1() {
    this.visible = true;

    this.content.goToFrame(1);
    this.symbol = this.content.getChildByName('symbol');
    this.titleText = this.content.getChildByName('freespins_start_label1');
    this.title2Text = this.content.getChildByName('freespins_start_label2');
    this.freeSpinsAmount = this.content.getChildByName('amount');

    this.freeSpinsAmount.style = { ...this.freeSpinsAmount.style, ...goldStyle };
    this.titleText.style = { ...this.titleText.style, ...freeSpinsWindowStyle };
    this.title2Text.style = { ...this.title2Text.style, ...freeSpinsWindowStyle };
    this.title2Text.fitSize(true, true);

    this.freeSpinsAmount.text = EntryPoint.GameModel.freeSpins.amount_given;
    SoundManager.play(eSounds.EST_WIN_FREESPINS.name, eSounds.EST_WIN_FREESPINS.volume, false, eSounds.EST_WIN_FREESPINS.group);

    this.timeout = setTimeout(this._complete.bind(this), this._addFreeSpinsDuration);
  }

  initPage2() {
    this.visible = true;

    this.content.goToFrame(2);
    this.titleText = this.content.getChildByName('freespins_total_win_label1');
    this.title2Text = this.content.getChildByName('freespins_total_win_label2');
    this.totalWinAmount = this.content.getChildByName('amount');

    this.totalWinAmount.style = { ...this.totalWinAmount.style, ...goldStyle };
    this.titleText.style = { ...this.titleText.style, ...freeSpinsWindowStyle, fontSize: 72 };
    this.title2Text.style = { ...this.title2Text.style, ...freeSpinsWindowStyle };
    this.title2Text.fitSize(true, true);

    // this.coinsContainer.visible = true;
    // this.coinParticles.start();
    SoundManager.play(eSounds.EST_FREESPINS_TOTAL_WIN.name, eSounds.EST_FREESPINS_TOTAL_WIN.volume, false, eSounds.EST_FREESPINS_TOTAL_WIN.group);

    this.animateValue(EntryPoint.GameModel.freespinsTotalWin, this.totalWinAmount, this._totalWinDuration, EntryPoint.GameModel.currencyInfo.decimals, EntryPoint.GameModel.currencyInfo.symbol);
  }

  initParticles() {
    const x = this.displayData.width / 2;
    const y = this.content.height / 2.5;

    this.coinsContainer = new PIXI.Container();
    this.coinsContainer.x = x;
    this.coinsContainer.y = y;

    this.coinParticles = new ParticleSystem(this.coinsContainer, { animationType: 'coins', animationName: 'coin' }, {
      ...particlesConfig.coinParticlesConfig,
      x0min: 0,
      x0max: 0,
      y0min: 0,
      y0max: 0,
      v0max: 1.4,
      angle0From: -Math.PI / 180 * 120,
      angle0To: -Math.PI / 180 * 60,
      count: 160
    });

    this.addChild(this.coinsContainer);
  }

  animateValue(value, element, duration, decimals, postfix) {
    this.winAmountCounter.animate(0, value, decimals, duration, element, postfix);
  }

  _onWinAnimationEnd() {
    this.timeout = setTimeout(this._complete.bind(this), this._delayBeforeClose);
  }

  _complete() {
    GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_WINDOW_SHOWED);
  }
}

